import React from "react"

import { Link, graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"

import "./hero.css"

const Banner = () => {
  // const { heroImage } = useStaticQuery(
  //   graphql`
  //     {
  //       heroImage: file(relativePath: { eq: "new-images/warehouse.jpg" }) {
  //         childImageSharp {
  //           gatsbyImageData(
  //             width: 1920
  //             layout: CONSTRAINED
  //             formats: [AUTO, WEBP, AVIF]
  //           )
  //         }
  //       }
  //     }
  //   `
  // )

  // const heroImageData = getImage(heroImage)

  // // Use like this:
  // const bgImage = convertToBgImage(heroImageData)

  return (
    <>
      <div
        // Tag="div"
        // {...bgImage}
        // fluid={imageData}
        className="hero-banner hero-whitefade-banner"
        // preserveStackingContext
        style={{ backgroundPosition: "top center" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-7 mr-auto">
              <div className="hero-procurement">
                <h5 className="text-light-blue text-uppercase font-weight-bold mt-0 mb-4">
                  Procurement Automation Services
                </h5>
                <h1 className="page-title font-weight-medium mt-0 mb-4">
                  Achieve Optimal Efficiency With Procurement Automation
                </h1>
                <p>
                  Transform your procurement process into a strategic asset that
                  drastically reduces costs while providing new insights across
                  your entire organization.
                </p>
                <p>
                  <Link
                    aria-label="link"
                    className="font-weight-medium"
                    to="/contact/"
                  >
                    Speak to a Technology Consultant
                    <i className="ml-2 item-arrow" aria-hidden="true"></i>
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Banner
